import {
  SUPPORT_TICKET_LIST,
  SUPPORT_TICKET_CREATE,
  SUPPORT_TICKET_VIEW,
  SUPPORT_TICKET_EDIT,
  SUPPORT_TICKET_DELETE,
  SUPPORT_TICKET_STATUS,
} from "./apiRoutes";
import { authData } from "./Service";

export const listOfSupportTicketsApi = async (data) => {
  const response = await authData.post(SUPPORT_TICKET_LIST, data);
  return response?.data;
};

export const createSupportTicketApi = async (data) => {
  const response = await authData.post(SUPPORT_TICKET_CREATE, data);
  return response?.data;
};

export const viewSupportTicketApi = async (id) => {
  const response = await authData.get(`${SUPPORT_TICKET_VIEW}${id}`);
  return response?.data;
};

export const editSupportTicketApi = async (id, data) => {
  const response = await authData.put(`${SUPPORT_TICKET_EDIT}${id}`, data);
  return response?.data;
};

export const deleteSupportTicketApi = async (id) => {
  const response = await authData.delete(`${SUPPORT_TICKET_DELETE}${id}`);
  return response?.data;
};

export const updateSupportTicketStatusApi = async (id, data) => {
  const response = await authData.put(`${SUPPORT_TICKET_STATUS}${id}`, data);
  return response?.data;
};
